// Navigations

let menuTimer;
let menu = {
	$item: $('.nav-top__drop'),
	$tablink: $('[data-drop-open]'),
	$trigger: $('.nav-left__menu--toggle'),
};

menu.$item.on('mouseover', (e) => {
	if (innerWidth >= 900) {
		clearTimeout(menuTimer);
		$('.nav-top__drop__menu').addClass('is-hidden');
		$(e.currentTarget).find('.nav-top__drop__menu').removeClass('is-hidden');
		$('html').addClass('is-top-menu-open');
		$(e.currentTarget).find('ul:not([class])').css({
			paddingLeft: $(e.currentTarget).offset().left - $(e.currentTarget).find('ul').offset().left,
		});
	}
});

menu.$item.on('mouseleave', (e) => {
	if (innerWidth >= 900) {
		menuTimer = setTimeout(() => {
			$('.nav-top__drop__menu').addClass('is-hidden');
			$('html').removeClass('is-top-menu-open');
		}, 400);
	}
});

menu.$tablink.on('click', (e) => {
	if (innerWidth >= 900) {
		e.preventDefault();

		let $this = $(e.currentTarget);

		if ($this.hasClass('is-active')) {
			return;
		}

		$('[data-drop]').addClass('is-hidden');
		$(`[data-drop="${$this.data('drop-open')}"]`).removeClass('is-hidden');
		menu.$tablink.removeClass('is-active');
		menu.$tablink.filter(`[data-drop-open="${$this.data('drop-open')}"]`).addClass('is-active');
		$this.trigger('blur');
	}
});

menu.$trigger.on('click', (e) => {
	if (innerWidth >= 900) {
		$('html').toggleClass('is-popup-menu-open');
	} else {
		$('html').toggleClass('is-mobile-menu-open');
	}
	$(e.currentTarget).trigger('blur');
});

// Home intro slider

$('.home__intro__slider').slick({
	autoplay: true,
	autoplaySpeed: 5000,
	fade: true,
	dots: true,
	arrows: false,
})

// Home news slider

$('.home__news-slider').slick({
	infinite: true,
	slidesToShow: 1,
	centerMode: true,
	variableWidth: true,
	speed: 500,
	responsive: [
		{
			breakpoint: 899,
			settings: {
				centerMode: false,
				variableWidth: false,
			},
		},
	],
});

$('.home__news-slider').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
	let $curr = $(`[data-slick-index="${currentSlide}"]`);
	if ((currentSlide > nextSlide && (nextSlide !== 0 || currentSlide === 1)) || (currentSlide === 0 && nextSlide === slick.slideCount - 1)) {
		if ($curr.prev().hasClass('slick-cloned')) {
			$curr.prev().addClass('slick-cloned-current');
		}
	}
	else {
		if ($curr.next().hasClass('slick-cloned')) {
			$curr.next().addClass('slick-cloned-current');
		}
	}
});

$('.home__news-slider').on('afterChange', () => {
	$('.slick-cloned').removeClass('slick-cloned-current');
});

// Home collection slider

$('.home__collection__slider').slick({
	slidesToShow: 4,
	responsive: [
		{
			breakpoint: 1300,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 899,
			settings: {
				slidesToShow: 1,
			},
		},
	],
});

// Footer scroll top

$('.footer__scrollTop').on('click', (e) => {
	e.preventDefault();

	$('html, body').animate({
		scrollTop: 0,
	}, 1500);
})
